import { render, staticRenderFns } from "./vehicleList.vue?vue&type=template&id=2918895e&scoped=true&"
import script from "./vehicleList.vue?vue&type=script&lang=js&"
export * from "./vehicleList.vue?vue&type=script&lang=js&"
import style0 from "./vehicleList.vue?vue&type=style&index=0&id=2918895e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2918895e",
  null
  
)

export default component.exports